import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
// Import Components
import { KeyValue } from '@geneui/components';
// Import Constants
import { l } from 'constants/common';
// Import Styles
import styles from './expandableContent.module.scss';

interface Props {
    content?: { label: string; value: number }[];
}

const ExpandableContent: FC<Props> = ({ content }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.title}>{t(l.Reason)}</div>
            {content?.map(({ label, value }, index) => (
                <KeyValue
                    key={index}
                    label={t(label)}
                    value={value}
                    appearance="horizontal"
                    className={styles.keyValue}
                />
            ))}
        </div>
    );
};

export default memo(ExpandableContent);
